import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import DashboardGrid from '../components/dashboard/DashboardGrid';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  // We can access theme to check mode if needed, but we'll use sx

  return (
    <Box>
      <DashboardGrid />

      {user && (
        <Box
          sx={{
            mt: 4,
            p: 2,
            bgcolor: 'background.paper',
            borderRadius: 2,
            border: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            boxShadow: 0
          }}
        >
          <Box>
            <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '0.1em', fontWeight: 600 }}>
              Active User
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {user.name}
            </Typography>
          </Box>

          <Box sx={{ height: 32, width: 1, bgcolor: 'divider' }} />

          <Box>
            <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '0.1em', fontWeight: 600 }}>
              Assigned Roles
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {user.roles.map(role => (
                <Typography
                  key={role}
                  variant="body2"
                  sx={{
                    color: 'secondary.main', // Sand color
                    fontWeight: 600,
                    fontFamily: 'monospace',
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(204, 186, 155, 0.1)' : 'rgba(15, 33, 52, 0.05)',
                    px: 1,
                    borderRadius: 0.5
                  }}
                >
                  {role}
                </Typography>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DashboardPage;